<template>
    <td>
        {{item.last_name}} <CBadge v-if="displayLoanIcon && item.transfer.length > 0" :color="getTransferBadge(item.transfer)">{{item.transfer}}</CBadge> <CButton v-if="statusIconNeeded(item.status)" class="status-button" size="sm" :color="getStatusBadge(item.status)" v-c-popover="{header: 'Player Status',content: item.news}">!</CButton>
        <br />
        <span class="d-lg-none">
            <b>{{item.position_short || item.position}}</b> {{item.team_name_short || item.team_name}}
        </span>
        <span class="d-none d-lg-block">
            <b>{{item.position}}</b> {{item.team_name}}
        </span>
    </td>
</template>

<script>
export default {
  name: 'TablePlayerItem',
  props: {
      item: Object,
      displayLoanIcon: {
          type: Boolean,
          default: false
      }
  },
  methods: {
    statusIconNeeded(status) {
      return ["d","u","i","s","n"].indexOf(status) > -1;
    },
    getStatusBadge (status) {
      return status == "d" ? "warning" : "danger";
    },
    getTransferBadge (status) {
      return status == "in" ? "success" : "danger";
    }
  }
}
</script>